export default __webpack_public_path__ + "static/media/get_started_step_2.b1e2b4ae.png";